// TOOGLE_EARLY_CART_EXPERIENCE
// TODO: Delete this file
import { computed } from 'vue';

import { useStore } from '@/store';
import { useVerifyLocation } from '@account/composables';

const store = useStore();
const { isNationalUser } = useVerifyLocation();
const isToggleEarlyCartExperienceEnabled = computed(
  () => store.getters['info/getAccount'].toggles.earlyCartExperience
);

export const useEarlyCartExperience = () => {
  const isEarlyCartExperienceEnabled = computed(() => {
    return isToggleEarlyCartExperienceEnabled.value && isNationalUser.value;
  });

  return { isEarlyCartExperienceEnabled };
};
